


























































































helpers = require('../../helpers.coffee')

view_model =
  components:
    emailServiceDropdown: require('./email_service_dropdown')
    additionalMinute: require('./additional_minute')

  data: ->
    company: new Company
    account_setting_selected: null
    account_setting: new AccountSetting
    max_duration_in_mintues: 0
    plivo_setting: null
    minutes_to_add: 0
    voip_service: 'plivo'
    voip_services: [
      { value: 'plivo', text: 'Plivo' }
      { value: 'twilio', text: 'Twilio' }
    ]

  computed:
    regular_users_upper_limit: ->
      switch @account_setting_selected.name
        when 'basic' 
          3
        when 'developer' 
          8
        when 'premium' 
          12
        when 'enterprise' 
          100
        else 
          0

    default_regular_users_bottom_limit: ->
      switch @account_setting_selected.name
        when 'basic'
          1
        when 'developer'
          3
        when 'premium' 
          9
        when 'enterprise' 
          13
        else 
          0
    
    regular_users_bottom_limit: ->
      Math.max @company.number_of_regular_users, this.default_regular_users_bottom_limit

    voip_active: ->
      @company.isPlivo() || @company.isTwilio()

    max_duration_in_minutes:
      get: ->
        return 0 unless @plivo_setting || @twilio_setting
        if @plivo_setting && @company.isPlivo()
          @plivo_setting.voip_monthly_plan.max_duration / 60
        else if @twilio_setting && @company.isTwilio()
          @twilio_setting.voip_monthly_plan.max_duration / 60
      set: (value) ->
        return unless @plivo_setting || @twilio_setting
        if @plivo_setting && @company.isPlivo()
          @plivo_setting.voip_monthly_plan.max_duration = parseInt(value || 0) * 60
        else if @twilio_setting && @company.isTwilio()
          @twilio_setting.voip_monthly_plan.max_duration = parseInt(value || 0) * 60

  methods:
    toggleActiveCompany: ->
      @company.active = !@company.active

    submit: ->
      @$validator.validateAll().then =>
        @save()

    loadCompany: ->
      Loader.on()
      new CompaniesResource().get(@loadCompanySuccess, @handleApiErrors, { id: @company_id })

    loadCompanySuccess: (data) ->
      @company = data.company
      @voip_service = @company.voip_service
      @plivo_setting = @company.plivo_setting
      @twilio_setting = @company.twilio_setting
      @account_setting_selected = {}
      if @company.account_setting && !(@company.account_setting instanceof Array)
        selected = Object.assign({}, @company.account_setting_options().account_settings.find ((setting) -> setting.value.name == data.company.account_setting.name))
        @account_setting_selected = selected.value if selected
        @account_setting.max_number_of_regular_users = @company.account_setting.max_number_of_regular_users || 0
        @account_setting.max_number_of_monitoring_managers = @company.account_setting.max_number_of_monitoring_managers || 0
        @account_setting = @company.account_setting
      else
        @account_setting_selected = { name: 'basic', max_number_of_regular_users: 3 }
      Loader.off()

    updateCompany: ->
      @account_setting.name = @account_setting_selected.name
      @account_setting.max_number_of_regular_users = parseInt(@account_setting.max_number_of_regular_users)
      @account_setting.max_number_of_monitoring_managers = parseInt(@account_setting.max_number_of_monitoring_managers)
      @account_setting.company_id = @company.id
      @company.account_setting = @account_setting

    verifyUsers: ->
      if @company.max_number_of_regular_users > @account_setting_selected.max_number_of_regular_users ||
         @company.max_number_of_monitoring_managers > parseInt(@account_setting.max_number_of_monitoring_managers)
        alertify.error this.$t('companies.feedback.contactsExceeded')
        return false
      else
        return true

    updatePlivoSettingAttributes: ->
      if @company.isPlivo()
        @company.plivo_setting_attributes = {
          id: @plivo_setting.id
          max_duration: @plivo_setting.max_duration
          additional_time: @plivo_setting.additional_time
        }
      else
        @company.plivo_setting_attributes = null

    updateTwilioSettingAttributes: ->
      if @company.isTwilio()
        @company.twilio_setting_attributes = {
          id: @twilio_setting.id
          max_duration: @twilio_setting.max_duration
          additional: @twilio_setting.additional_time
        }
      else
        @company.twilio_setting_attributes = null

    save: ->
      Loader.on()
      return if !@verifyUsers()
      @updateCompany()
      @company.plivo_setting = @plivo_setting
      @company.twilio_setting = @twilio_setting
      new CompaniesResource().update(@saveSuccess, @handleApiErrors, @company.serialize())

    saveSuccess: ->
      Loader.off()
      alertify.success(this.$t('companies.feedback.updated'))
      @$router.push('/configuracoes/empresas')

    setVoipService: ->
      Loader.on()
      new CompaniesResource().update(@toggleServiceSuccess, @handleApiErrors, {id: @company.id, @voip_service})

    toggleVoipService: ->
      voip_service = null
      if !@company.voip_service
        voip_service = 'plivo'
      Loader.on()
      new CompaniesResource().update(@toggleServiceSuccess, @handleApiErrors, {id: @company.id, voip_service})

    toggleServiceSuccess: (data) ->
      alertify.success(this.$t('companies.feedback.saved'))
      @loadCompanySuccess(data)

      Loader.on()
      new CompaniesResource().update(@toggleServiceSuccess, @handleApiErrors, @company.serialize())

    addMinutes: ->
      if @company.isPlivo()
        @plivo_setting.voip_additional_times.push new VoipAdditionalTime(user_id: Session.current_user.id)
      else if @company.isTwilio()
        @twilio_setting.voip_additional_times.push new VoipAdditionalTime(user_id: Session.current_user.id)

  created: ->
    @company_id = @$route.params.id
    @loadCompany()

exports.default = helpers.vue_include(view_model, helpers.form)




// WEBPACK FOOTER //
// ./~/vue-loader/lib/selector.js?type=script&index=0!./src/views/companies/edit.vue